import { action, observable, computed } from 'mobx';

import { GET_ANCHOR_ID_BY_USERNAME } from '../constants/apiUrls/apiUrls';
import forResponse from '../utils/forResponse';
import http from '../services/http';


class TippingStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }

    @observable showTippingModal = false;
    @observable anchor = { name: '', id: '', username: '' };
    @observable spotlightAnchor = { name: '', id: '', username: '' };

    @computed get anchorShortUrl() {
      const { name } = this.anchor;
      const { id } = this.anchor;
      let anchorShortUrl = '';

      if (name && id) {
        const anchorName = name.toLowerCase().split(' ').join('-');
        anchorShortUrl = `naked-news-anchor-${anchorName}-a${id}`;
      }

      return anchorShortUrl;
    }

    @action
      setTippingModal = async(anchor, spotlightAnchorNickname, spotlightAnchorUsername) => {
        if (anchor.id && !spotlightAnchorNickname) {
          this.anchor = anchor;
          this.showTippingModal = true;
        } else if (spotlightAnchorNickname) {
          const {
            data: {
              data: {
                name,
                id,
                username,
              },
            },
          } = await this.getListOfActiveAnchorsMemberSubscribedTo(anchor.username);
          const { data, error } = await this.getListOfActiveAnchorsMemberSubscribedTo(spotlightAnchorNickname);
          this.anchor = { name, id, username };
          if (data) {
            this.spotlightAnchor = {
              name: data.data.name,
              id: data.data.id,
              username: data.data.username,
            };
          } else if (error && spotlightAnchorUsername) {
            const {
              fallBackAnchorData,
              fallBackAnchorError,
            } = await this.getListOfActiveAnchorsMemberSubscribedTo(spotlightAnchorUsername);
            if (!fallBackAnchorError) {
              this.spotlightAnchor = {
                name: fallBackAnchorData?.data?.name,
                id: fallBackAnchorData?.data?.id,
                username: fallBackAnchorData?.data?.username,
              };
            }
          }
          this.showTippingModal = true;
        } else {
          const {
            data: {
              data: {
                name,
                id,
                username,
              },
            },
          } = await this.getListOfActiveAnchorsMemberSubscribedTo(anchor.username);
          this.anchor = { name, id, username };
          this.showTippingModal = true;
        }
      };

    @action
      closeTippingModal = () => {
        this.showTippingModal = false;
      };

    getListOfActiveAnchorsMemberSubscribedTo = (username) => {
      const url = GET_ANCHOR_ID_BY_USERNAME.replace('{username}', username);

      return forResponse(
        http.get(url)
      );
    };
}

export default TippingStore;
